// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instance-sizes-wrapper[data-v-3f16681d] {\n  max-height: 400px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.outage-box[data-v-3f16681d] {\n  border: 1px solid #d9d9d9;\n}\n.iops-warn-text[data-v-3f16681d] {\n  color: #f59d34;\n}", ""]);
// Exports
module.exports = exports;
